import React, { createContext, useContext } from 'react';

const EnterpriseManageContext = createContext(null);

export function EnterpriseManageProvider({ value, children }) {
  return (
    <EnterpriseManageContext.Provider value={value}>
      {children}
    </EnterpriseManageContext.Provider>
  );
}

export function useEnterpriseManage() {
  const ctx = useContext(EnterpriseManageContext);
  if (!ctx) {
    throw new Error('useEnterpriseManage doit être utilisé dans EnterpriseManageLayout');
  }
  return ctx;
}
